import PropTypes from 'prop-types'

/**
 * PremiumCelebration uses this helper module to centralize prop meta in our
 * JavaScript codebase.
 */

/**
 * @typedef {Object} CelebrationCta
 * @property {string} label - CTA button label.
 * @property {() => void} onClick - Callback fired when CTA is pressed.
 */

export const celebrationCtaPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
})

export const premiumCelebrationPropTypes = {
  isVisible: PropTypes.bool,
  message: PropTypes.string,
  subcopy: PropTypes.string,
  cta: celebrationCtaPropType,
  onDismiss: PropTypes.func,
  className: PropTypes.string,
  confettiProps: PropTypes.object,
  variant: PropTypes.oneOf(['overlay', 'inline']),
  autoDismissDelay: PropTypes.number,
}

export const premiumCelebrationDefaultProps = {
  isVisible: false,
  message: "Welcome to Luna's inner sanctum!",
  subcopy: '',
  cta: null,
  onDismiss: undefined,
  className: '',
  confettiProps: undefined,
  variant: 'overlay',
  autoDismissDelay: undefined,
}

export const premiumCelebrationTypeHelpers = {
  celebrationCtaPropType,
  premiumCelebrationPropTypes,
  premiumCelebrationDefaultProps,
}

export default premiumCelebrationTypeHelpers
